import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <footer className="bg-black text-white py-16 px-6 md:px-12 lg:px-24" data-id="element-448">
      <div className="max-w-7xl mx-auto" data-id="element-449">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-450">
          {/* Logo and Description */}
          <div className="md:col-span-1" data-id="element-451">
            <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8 mb-4 brightness-0 invert" data-id="element-452" />
            <p className="text-sm text-gray-400 leading-relaxed" data-id="element-453">
              The Contextual Intelligence Company.
            </p>
          </div>

          {/* Solutions - FIXED ORDER TO MATCH NAVIGATION */}
          <div data-id="element-454">
            <h4 className="font-['Syne'] font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-455">
              Solutions
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-456">
              <li data-id="element-457">
                <Link to="/the-instruction-layer" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-458">
                  The Instruction Layer
                </Link>
              </li>
              <li data-id="element-459">
                <Link to="/context-engineering" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-460">
                  Context Engineering
                </Link>
              </li>
              <li data-id="element-461">
                <Link to="/how-it-works" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-462">
                  How It Works
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-463">
            <h4 className="font-['Syne'] font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-464">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-465">
              <li data-id="element-466">
                <Link to="/about" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-467">
                  About Synthia
                </Link>
              </li>
              <li data-id="element-468">
                <Link to="/blog" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-469">
                  Blog
                </Link>
              </li>
              <li data-id="element-470">
                <Link to="/contact" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-471">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-472">
            <h4 className="font-['Syne'] font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-473">
              Legal
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-474">
              <li data-id="element-475">
                <Link to="/terms" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-476">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-477">
                <Link to="/privacy" onClick={scrollToTop} className="hover:text-white transition-colors" data-id="element-478">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-479">
          <p className="text-sm text-gray-500" data-id="element-480">
            © 2026 meetsynthia.ai, Inc. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-481">
            <a href="https://www.linkedin.com/company/meetsynthia-ai/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-482">
              LinkedIn
            </a>
            <a href="https://x.com/meetsynthiaAI" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-483">
              X
            </a>
          </div>
        </div>
      </div>
    </footer>;
}